<template>
  <div class="layout-box">
    <LayoutHeader headtitle="化纤指数"></LayoutHeader>
    <div class="secondary-content">
      <div class="indexmacro-l">
        <div class="borderl">
          <h3>进出口情况</h3>
          <div class="borderl-mian" id="importexport"></div>
        </div>
        <div class="borderl" style="margin-top: 20px">
          <h3>市场价格</h3>
          <div class="borderl-mian" id="marketprice"></div>
        </div>
      </div>
      <div class="indexmacro-c">
        <div class="indexmacro-c-t">
          <div class="indexmacro-c-t-l"><span :class="ids==1?'on':''" @click="getweekindex(1)">负荷</span><span :class="ids==2?'on':''" @click="getweekindex(2)">库存</span><span :class="ids==3?'on':''" @click="getweekindex(3)">价格</span></div>
          <div class="indexmacro-c-t-r">
            <div class="weekindex" v-for="(item,index) in weekdata" :class="item.loseAvg<0?'fall':(item.loseAvg>0?'rose':'')" :key="index">
              <div class="weekindex-bg" :class="clickid==index+1?'on':''" @click="getdayindex(item.customType)"><font class="triangle"></font></div>
              <h3>{{index+1 | getname}}</h3><p><span><b>{{ ids==3?item.monthAvg.toFixed(0):item.monthAvg.toFixed(1) }}</b></span><span><i style="margin-top: 2px">{{ ids==3?item.loseAvg.toFixed(0):item.loseAvg.toFixed(1) }}</i><i>{{ item.percentage.toFixed(1) }}%</i></span></p>
            </div>
          </div>
        </div>
        <div class="indexmacro-c-b">
          <div class="indexmacro-c-b-mian" id="loadindex"></div>
          <div class="indexmacro-c-b-mian" id="piindex"></div>
        </div>
      </div>
      <div class="indexmacro-r">
        <div class="borderr">
          <h3>上游原料价格</h3>
          <div class="borderr-mian" id="uprice"></div>
        </div>
        <div class="borderr">
          <h3>化纤经济效益</h3>
          <div class="borderr-mian" id="economicbenefit"></div>
        </div>
        <div class="borderr">
          <h3>固定资产投资</h3>
          <div class="borderr-mian" id="fixedassets"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LayoutHeader from "../layout/layout-header2";
export default {
  name: "indexmacro",
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components:{
    LayoutHeader
  },
  filters:{
    getname(n){
      let name=''
      switch (n) {
        case 1:
          name='涤纶长丝'
          break;
        case 2:
          name='涤纶短纤'
          break;
        case 3:
          name='锦纶长丝'
          break;
        case 4:
          name="粘胶短纤"
          break
        case 5:
          name='氨纶'
          break;
      }
      return name
    }
  },
  data () {
    return {
      ids: '',
      clickid:1,
      weekdata:[{loseAvg:0,monthAvg:0,percentage:0},{loseAvg:0,monthAvg:0,percentage:0},{loseAvg:0,monthAvg:0,percentage:0},{loseAvg:0,monthAvg:0,percentage:0},{loseAvg:0,monthAvg:0,percentage:0}]
    }
  },
  created () {
    localStorage.setItem('gotourl', window.location.hash)
  },
  mounted () {
    let $this = this
    $this.dataRefresh.$ons('Refresh', () => {
      $this.getdata()
    })
    setTimeout(function () {
      $this.getdata()
      $this.getdayindex($this.clickid)
    },500)
  },
  methods:{
    getdata(){
      this.ids=this.$route.query.id||1
      const url = '/api-portal/load/indexList';
      this.$api.post(url, {indexType:this.ids}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          this.weekdata=datas.data
        }
      },'json')
      const url2 = '/api-portal/load/upPriceList';
      this.$api.post(url2, {}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          const wti = datas.data['256'] || []
          const pta = datas.data['2182'] || []
          const poy = datas.data['70'] || []
          let times=[]
          let data1= new Array(wti.length).fill('')
          let data2= new Array(wti.length).fill('')
          let data3= new Array(wti.length).fill('')
          wti.map((item,index)=>{
            const time=item.thisMonth
            const num=item.monthAvg==0?'':item.monthAvg
            times.push(time)
            data1.splice(index, 1, num)
          })
          pta.map((item,index)=>{
            const num=item.monthAvg==0?'':item.monthAvg
            data2.splice(index, 1, num)
          })
          poy.map((item,index)=>{
            const num=item.monthAvg==0?'':item.monthAvg
            data3.splice(index, 1, num)
          })
          this.renderuprice(data1,data2,data3,times)
        }
      })

      const url3 = '/api-portal/load/loadChemicalFiber';
      this.$api.post(url3, {}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          let data1= []
          let data2= []
          let data3= []
          let data4= []
          let time=''
          datas.data.map((item,index)=>{
            const num=item.monthAvg
            time=item.thisMonth.substring(0,7)
            switch ((index+1)%4) {
              case 1:
                data1.push(num)
                break;
              case 2:
                data2.push(num)
                break;
              case 3:
                data3.push(num)
                break;
              case 0:
                data4.push(num)
                break;
            }
          })
          this.rendereconomicbenefit(data1,data2,data3,data4,time)
        }
      })
      const url4 = '/api-portal/load/loadFixedAsset';
      this.$api.post(url4, {}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          let dataall=datas.data||[]
          let data1=[],data2=[]
          dataall.map(item=>{
            const time=item.thisMonth.substring(0,7)
            const num=item.monthAvg
            data1.push(time)
            data2.push(num)
          })
          this.renderfixedassets(data1,data2)
        }
      })
    },
    getweekindex(num){
      this.ids=num
      const url = '/api-portal/load/indexList';
      this.weekdata=[{loseAvg:0,monthAvg:0,percentage:0},{loseAvg:0,monthAvg:0,percentage:0},{loseAvg:0,monthAvg:0,percentage:0},{loseAvg:0,monthAvg:0,percentage:0},{loseAvg:0,monthAvg:0,percentage:0}]
      this.$api.post(url, {indexType:this.ids}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          this.weekdata=datas.data
        }
      },'json')
    },
    getdayindex(num){
      this.clickid=num
      const url = '/api-portal/load/inventoryPriceList';
      this.$api.post(url, {customType:this.clickid}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          const inventory = datas.data.inventory || []
          const price = datas.data.price || []
          let times=[]
          let data1= new Array(inventory.length).fill('')
          let data2= new Array(inventory.length).fill('')
          let name1=this.$options.filters['getname'](this.clickid)+'价格'
          let name2=this.$options.filters['getname'](this.clickid)+'库存'
          inventory.map((item,index)=>{
            const time=item.thisMonth
            const num=item.monthAvg?item.monthAvg.toFixed(2):''
            times.push(time)
            data2.splice(index, 1, num)
          })
          price.map((item,index)=>{
            const num=item.monthAvg?item.monthAvg.toFixed(2):''
            data1.splice(index, 1, num)
          })
          this.renderipindex(data1,data2,times,name1,name2)
        }
      },'json')
      const url2 = '/api-portal/load/loadList';
      this.$api.post(url2, {customType:this.clickid}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          const lastYear = datas.data.lastYear || []
          const thisYear = datas.data.thisYear || []
          const beforeLastYear = datas.data.beforeLastYear || []
          let times=[]
          let data1= new Array(lastYear.length).fill('')
          let data2= new Array(lastYear.length).fill('')
          let data3= new Array(lastYear.length).fill('')
          const name1=lastYear[0].thisMonth.substring(0,4)
          const name2=thisYear[0]?thisYear[0].thisMonth.substring(0,4):new Date().getFullYear()
          const name3=beforeLastYear[0].thisMonth.substring(0,4)
          lastYear.map((item,index)=>{
            const time=item.thisMonth.substring(5)
            const num=item.monthAvg
            times.push(time)
            data1.splice(index, 1, num)
          })
          beforeLastYear.map((item,index)=>{
            const num=item.monthAvg
            data3.splice(index, 1, num)
          })
          if(thisYear.length>0){
            thisYear.map((item,index)=>{
              const num=item.monthAvg
              data2.splice(index, 1, num)
            })
          }
          this.renderloadindex(data1,data2,data3,times,name1,name2,name3)
        }
      },'json')
      const url3 = '/api-portal/load/loadMarketPrice';
      this.$api.post(url3, {customType:this.clickid,pageNum:1,pageSize:20}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          const datalist=datas.data.dataList||[]
          let time=[],names=[]
          for(var key in datalist){
            time.push(key.substring(0,7))
            const dat=datalist[key]
            dat.map(item=>{
              const id=item.customID
              const name=item.customName
              if(JSON.stringify(names).indexOf(id)<0){
                let arr={
                  'id':id,
                  'name':name
                }
                names.push(arr)
              }
            })
          }
          var objData = {}
          names.map(item=>{
            objData['monthAvg'+item.id]=new Array(time.length).fill('')
            objData['percentage'+item.id]=new Array(time.length).fill('')
            objData['loseAvg'+item.id]=new Array(time.length).fill('')
          })
          let nums=0
          for(var keys in datalist){
            const dats=datalist[keys]
            dats.map(item=>{
              const id=item.customID
              const monthAvg=item.monthAvg?item.monthAvg.toFixed(0)*1:''
              const percentage=item.percentage?item.percentage.toFixed(3)*1:''
              const loseAvg=item.loseAvg?item.loseAvg.toFixed(2)*1:''
              objData['monthAvg'+id].splice(nums, 1, monthAvg)
              objData['percentage'+id].splice(nums, 1, percentage)
              objData['loseAvg'+id].splice(nums, 1, loseAvg)
            })
            nums++
          }
          this.rendermarketprice(time,objData,names)
        }
      },'json')
      const url4 = '/api-portal/load/loadImportExport';
      this.$api.post(url4, {customType:this.clickid,pageNum:1,pageSize:20}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          let datalist=datas.data.dataList||[]
          let exportList=datas.data.exportList||[]
          let importList=datas.data.importList||[]
          let time=[],data1=[],data2=[],data3=[],data4=[]
          for(var key in datalist){
            time.push(key.substring(0,2))
            data1.push(datalist[key][0].monthAvg) // 进口
            data2.push(datalist[key][1].monthAvg) // 出口
          }
          exportList.map((item,index)=>{ // 出口
            const num=item.percentage.toFixed(2)
            data4.push(num)
          })
          importList.map((item,index)=>{ // 进口
            const num=item.percentage.toFixed(2)
            data3.push(num)
          })
          let name1=this.$options.filters['getname'](this.clickid)+'进口'
          let name2=this.$options.filters['getname'](this.clickid)+'出口'
          this.renderimportexport(time,data1,data2,data3,data4,name1,name2)
        }
      },'json')
    },
    compareDate(t1,t2){
      const time1=new Date(t1.replace(/-/g, '/')).getTime();
      const time2=new Date(t2.replace(/-/g, '/')).getTime();
      if(time1<time2){
        return true
      }else {
        return false
      }
    },
    renderloadindex(data1,data2,data3,times,name1,name2,name3){
      const $this=this
      const myEchartst = $this.$echarts.init(document.getElementById('loadindex'))
      let option = {
        tooltip: {
          trigger: 'axis',
          position: function (pt) {
            return [pt[0], '10%'];
          }
        },
        legend: {
          textStyle: {
            color: '#C1D3F4',
            fontSize:14
          },
          itemWidth:12,
          itemHeight:4,
          padding: [20, 0, 0, 0]
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '18%',
          containLabel: true
        },
        graphic: [{
          type:'image',
          silent:true,
          z: 100,
          left: 'center',
          top: 'middle',
          bounding:'all',
          style: {
            image:require('../../assets/secondary/watermark.png'),
            width:148,
            height:88
          }
        }],
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          data: times
        },
        yAxis: {
          type: 'value',
          name:'负荷(周)',
          min:val=>{
            return Math.ceil(val.min-5)>0? Math.ceil(val.min-5):val.min
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#5788EC'
            }
          },
          nameTextStyle:{
            color: '#C1D3F4',
            fontSize:16,
            padding:[0,0,0,-20]
          },
          splitLine:{
            lineStyle: {
              color: '#2C53C7'
            }
          },
          axisLabel: {
            color: '#C1D3F4',
            // formatter: function (params) {
            //   return params+'亿'
            // }
          }
        },
        series: [
          {
            name: name1,
            type: 'line',
            data: data1,
            showSymbol:false,
            smooth: true,
            markPoint: {
              data: [
                { type: 'max',
                  name: 'Max',
                  itemStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: '#f00'
                        }, {
                          offset: 1,
                          color: 'rgb(255, 158, 68)'
                        }
                      ]
                    }
                  } },
                { type: 'min', name: 'Min' }
              ]
            },
            itemStyle: {
              color: '#f00'
            },
            areaStyle: {
              color: new $this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(255, 158, 68)'
                },
                {
                  offset: 1,
                  color: 'rgb(255, 70, 131)'
                }
              ])
            }
          },
          {
            name: name2,
            type: 'line',
            data: data2,
            showSymbol:false,
            smooth: true,
            markPoint: {
              data: [
                { type: 'max',
                  name: 'Max',
                  itemStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: '#427FE0'
                        }, {
                          offset: 1,
                          color: 'rgb(255, 158, 68)'
                        }
                      ]
                    }
                  } },
                { type: 'min', name: 'Min' }
              ]
            },
            itemStyle: {
              color: '#427FE0'
            },
            areaStyle: {
              color: new $this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(255, 158, 68)'
                },
                {
                  offset: 1,
                  color: '#427FE0'
                }
              ])
            }
          },
          {
            name: name3,
            type: 'line',
            data: data3,
            showSymbol:false,
            smooth: true,
            markPoint: {
              data: [
                { type: 'max',
                  name: 'Max',
                  itemStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: '#3ACB78'
                        }, {
                          offset: 1,
                          color: '#EDA747'
                        }
                      ]
                    }
                  } },
                { type: 'min', name: 'Min' }
              ]
            },
            itemStyle: {
              color: '#3ACB78'
            },
            areaStyle: {
              color: new $this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#EDA747'
                },
                {
                  offset: 1,
                  color: '#3ACB78'
                }
              ])
            }
          }
        ]
      }
      myEchartst.setOption(option,true)
    },
    renderipindex(data1,data2,times,name1,name2){
      const $this=this
      const myEchartst = $this.$echarts.init(document.getElementById('piindex'))
      let option = {
        tooltip: {
          trigger: 'axis',
          position: function (pt) {
            return [pt[0], '10%'];
          }
        },
        legend: {
          textStyle: {
            color: '#C1D3F4',
            fontSize:14
          },
          itemWidth:12,
          itemHeight:4,
          padding: [10, 0, 0, 0]
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '18%',
          containLabel: true
        },
        graphic: [{
          type:'image',
          silent:true,
          z: 100,
          left: 'center',
          top: 'middle',
          bounding:'all',
          style: {
            image:require('../../assets/secondary/watermark.png'),
            width:148,
            height:88
          }
        }],
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          data: times
        },
        yAxis: [
          {
            type: 'value',
            name:'价格',
            min:val=>{
              return parseInt(val.min/1000)*1000
            },
            axisLine:{
              show:true,
              lineStyle:{
                color:'#5788EC'
              }
            },
            nameTextStyle:{
              color: '#C1D3F4',
              fontSize:16,
              padding:[0,0,0,-40]
            },
            splitLine:{
              lineStyle: {
                color: '#2C53C7'
              }
            },
            axisLabel: {
              color: '#C1D3F4',
              // formatter: function (params) {
              //   return params+'亿'
              // }
            }
          },{
            type: 'value',
            name:'库存',
            min:val=>{
              return Math.ceil(val.min-5)>0? Math.ceil(val.min-5):val.min
            },
            axisLine:{
              show:true,
              lineStyle:{
                color:'#5788EC'
              }
            },
            nameTextStyle:{
              color: '#C1D3F4',
              fontSize:16,
              padding:[40,0,0,0]
            },
            splitLine:{
              show: false
            },
            axisLabel: {
              color: '#C1D3F4',
              // formatter: function (params) {
              //   return params+'亿'
              // }
            }
          }
        ],
        series: [
          {
            name: name1,
            type: 'line',
            data: data1,
            yAxisIndex:0,
            showSymbol:false,
            smooth: true,
            markPoint: {
              data: [
                { type: 'max',
                  name: 'Max',
                  itemStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: '#FF00FF'
                        }, {
                          offset: 1,
                          color: '#FF0000'
                        }
                      ]
                    }
                  } },
                { type: 'min', name: 'Min' }
              ]
            },
            itemStyle: {
              color: '#FF00FF'
            },
            areaStyle: {
              color: new $this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#FF00FF'
                },
                {
                  offset: 1,
                  color: '#FF00FF'
                }
              ])
            }
          },
          {
            name: name2,
            type: 'line',
            data: data2,
            yAxisIndex:1,
            showSymbol:false,
            smooth: true,
            markPoint: {
              data: [
                { type: 'max',
                  name: 'Max',
                  itemStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: '#6BD700'
                        }, {
                          offset: 1,
                          color: '#FF0000'
                        }
                      ]
                    }
                  } },
                { type: 'min', name: 'Min'}
              ]
            },
            itemStyle: {
              color: '#00D936'
            },
            areaStyle: {
              color: new $this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#00D936'
                },
                {
                  offset: 1,
                  color: '#00D936'
                }
              ])
            }
          }
        ]
      }
      myEchartst.setOption(option,true)
    },
    renderuprice(data1,data2,data3,times){
      const $this=this
      const myEchartst = $this.$echarts.init(document.getElementById('uprice'))
      let option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          textStyle: {
            color: '#C1D3F4'
          },
          itemWidth:12,
          itemHeight:4,
          padding: [10, 0, 0, 0]
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '18%',
          containLabel: true
        },
        graphic: [{
          type:'image',
          silent:true,
          z: 100,
          left: 'center',
          top: 'middle',
          bounding:'all',
          style: {
            image:require('../../assets/secondary/watermark.png'),
            width:148,
            height:88
          }
        }],
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          data: times
        },
        yAxis: [
          {
            type: 'value',
            name:'元/吨',
            min:val=>{
              return parseInt(val.min/1000)*1000
            },
            axisLine:{
              show:true,
              lineStyle:{
                color:'#5788EC'
              }
            },
            nameTextStyle:{
              color: '#C1D3F4',
              fontSize:14,
              padding:[0,0,0,-40]
            },
            splitLine:{
              show: false
            },
            axisLabel: {
              color: '#C1D3F4',
              // formatter: function (params) {
              //   return params+'亿'
              // }
            }
          },{
            type: 'value',
            name:'美元/桶',
            min:val=>{
              return Math.ceil(val.min-5)>0? Math.ceil(val.min-5):val.min
            },
            axisLine:{
              show:true,
              lineStyle:{
                color:'#5788EC'
              }
            },
            nameTextStyle:{
              color: '#C1D3F4',
              fontSize:14,
              padding:[0,0,0,40]
            },
            splitLine:{
              show: false
            },
            axisLabel: {
              color: '#C1D3F4',
              // formatter: function (params) {
              //   return params+'亿'
              // }
            }
          }
        ],
        series: [
          {
            name: 'WTI',
            type: 'line',
            data: data1,
            yAxisIndex:1,
            connectNulls:true,
            showSymbol:false,
            itemStyle: {
              color: '#FF00FF'
            }
          },
          {
            name: '内盘PTA',
            type: 'line',
            data: data2,
            connectNulls:true,
            yAxisIndex:0,
            showSymbol:false,
            itemStyle: {
              color: '#FF0000'
            }
          },
          {
            name: '直纺半光POY',
            type: 'line',
            data: data3,
            connectNulls:true,
            yAxisIndex:0,
            showSymbol:false,
            itemStyle: {
              color: '#0BA46A'
            }
          }
        ]
      }
      myEchartst.setOption(option,true)
    },
    rendereconomicbenefit(d1,d2,d3,d4,time){
      const $this=this
      const myEchartst = $this.$echarts.init(document.getElementById('economicbenefit'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter:function (params) {
            let str = '';
            params.forEach((item, idx) => {
              str += idx != 0? '': item.axisValue+'（'+time+'）<br/>'
              str += `${item.marker}${item.seriesName}: ${item.data}`
              str += idx === params.length -1? '': '<br/>'
            })
            return str
          }
        },
        legend: {
          show:false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '18%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            axisLabel: {
              color: '#C1D3F4'
            },
            axisTick: { show: false },
            data: ['纺织业', '服装、服饰', '化学纤维制造']
          }
        ],
        yAxis: [
          {
            type: 'value',
            name:'亿元',
            nameTextStyle:{
              color: '#C1D3F4',
              fontSize:14,
              padding:[0,0,0,-35]
            },
            axisLabel: {
              color: '#C1D3F4'
            },
            axisLine:{
              show:true,
              lineStyle:{
                color:'#5788EC'
              }
            },
            splitLine:{
              show: false
            }
          },{
            type: 'value',
            name:'亿元',
            nameTextStyle:{
              color: '#C1D3F4',
              fontSize:14,
              padding:[0,0,0,30]
            },
            axisLabel: {
              color: '#C1D3F4'
            },
            axisLine:{
              show:true,
              lineStyle:{
                color:'#5788EC'
              }
            },
            splitLine:{
              show: false
            }
          }
        ],
        series: [
          {
            name: '营业收入',
            type: 'bar',
            barGap: 0,
            yAxisIndex:0,
            // label: labelOption,
            emphasis: {
              focus: 'series'
            },
            data: d1
          },
          {
            name: '营业成本',
            type: 'bar',
            yAxisIndex:0,
            // label: labelOption,
            emphasis: {
              focus: 'series'
            },
            data: d2
          },
          {
            name: '利润总额',
            type: 'bar',
            yAxisIndex:1,
            // label: labelOption,
            emphasis: {
              focus: 'series'
            },
            data: d3
          },
          {
            name: '亏损企业亏损额',
            type: 'bar',
            yAxisIndex:1,
            // label: labelOption,
            emphasis: {
              focus: 'series'
            },
            data: d4
          }
        ]
      }
      myEchartst.setOption(option,true)
    },
    renderfixedassets(data1,data2){
      const myEchartst = this.$echarts.init(document.getElementById('fixedassets'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter:function (params) {
            let str = '';
            params.forEach((item, idx) => {
              str += idx != 0? '': item.axisValue+'<br/>'
              str += `${item.marker}${item.seriesName}: ${item.data} %`
              str += idx === params.length -1? '': '<br/>'
            })
            return str
          }
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#C1D3F4'
          },
          axisLine:{
            lineStyle:{
              color:'#5788EC'
            }
          },
          data: data1
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#2345AB'
            }
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#5788EC'
            }
          },
          axisLabel: {
            color: '#C1D3F4',
            // formatter: function (params) {
            //   return params+'万'
            // }
          }
        },
        series: [{
            name: '固定资产',
            type: 'line',
            smooth: true,
            data: data2,
            markPoint: {
              data: [
                { type: 'max',
                  name: 'Max',
                  itemStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: '#f00'
                        }, {
                          offset: 1,
                          color: '#FCCF1B'
                        }
                      ]
                    }
                  } },
                { type: 'min', name: 'Min' }
              ]
            },
            lineStyle: {
              color: '#FDDD60'
            },
            color: '#FCCF1B'
          }
        ]
      }
      myEchartst.setOption(option,true)
    },
    renderimportexport (time,data1,data2,data3,data4,name1,name2) {
      const myEchartst = this.$echarts.init(document.getElementById('importexport'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter:function (params) {
            let str = '';
            params.forEach((item, idx) => {
              str += idx != 0? '': item.axisValue+'月<br/>'
              str += `${item.marker}${item.seriesName}: ${idx%2==1?item.data:item.data/1000} ${idx%2==1?'%':'吨'}`
              str += idx === params.length -1? '': '<br/>'
            })
            return str
          }
        },
        color:['#13C420','#FF9933','#0BA46A','#9933FF'],
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '18%',
          containLabel: true
        },
        graphic: [{
          type:'image',
          silent:true,
          z: 100,
          left: 'center',
          top: 'middle',
          bounding:'all',
          style: {
            image:require('../../assets/secondary/watermark.png'),
            width:148,
            height:88
          }
        }],
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          data: time
        },
        yAxis: [{
          type: 'value',
          name:'吨',
          nameTextStyle:{
            color: '#C1D3F4',
            padding:[0,0,0,-40]
          },
          axisLabel: {
            color: '#C1D3F4',
            formatter: function (params) {
              return parseInt(params/1000)
            }
          },
          min:val=>{
            return parseInt(val.min/1000)*1000
          },
          splitLine:{
            show:false
          }
        },{
          type: 'value',
          name:'%',
          axisLabel: {
            color: '#C1D3F4',
          },
          nameTextStyle:{
            color: '#C1D3F4',
            padding:[0,0,0,35]
          },
          splitLine: {
            lineStyle: {
              color: '#2345AB'
            }
          }
        }],
        series: [
          {
            name: name1,
            type: 'bar',
            stack: 'total',
            yAxisIndex:0,
            // label: {
            //   show: true
            // },
            emphasis: {
              focus: 'series'
            },
            data: data1
          },
          {
            name: name1+'同比',
            type: 'line',
            yAxisIndex:1,
            lineStyle: {
              color: '#0BA46A'
            },
            color: '#0BA46A',
            data: data3
          },
          {
            name: name2,
            type: 'bar',
            stack: 'total',
            yAxisIndex:0,
            // label: {
            //   show: true
            // },
            emphasis: {
              focus: 'series'
            },
            data: data2
          },
          {
            name: name2+'同比',
            type: 'line',
            yAxisIndex:1,
            lineStyle: {
              color: '#9933FF'
            },
            color: '#9933FF',
            data: data4
          }
        ]
      }
      myEchartst.setOption(option,true)
    },
    rendermarketprice(time,objData,names){
      const myEchartst = this.$echarts.init(document.getElementById('marketprice'))
      let data=[]
      names.map((item,index)=>{
        const id=item.id
        const name=item.name
        let obj={
          name: name,
          type: 'bar',
          yAxisIndex:0,
          emphasis: {
            focus: 'series'
          },
          data: objData['monthAvg'+id]
        }
        let obj2={
          name: name+'同比',
          type: 'line',
          yAxisIndex:1,
          // lineStyle: {
          //   color: '#0BA46A'
          // },
          // color: '#0BA46A',
          data: objData['loseAvg'+id]
        }
        data.push(obj)
        if(index==0){
          data.push(obj2)
        }
      })
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter:function (params) {
            let str = '';
            params.forEach((item, idx) => {
              str += idx != 0? '': item.axisValue+'<br/>'
              str += `${item.marker}${item.seriesName}: ${item.data||'-'} ${idx==1?'%':'元/吨'}`
              str += idx === params.length -1? '': '<br/>'
            })
            return str
          }
        },
        color:['#13C420','#FF9933','#FDDD60','#9933FF','#FF6E76','#DD16E3'],
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '18%',
          containLabel: true
        },
        graphic: [{
          type:'image',
          silent:true,
          z: 100,
          left: 'center',
          top: 'middle',
          bounding:'all',
          style: {
            image:require('../../assets/secondary/watermark.png'),
            width:148,
            height:88
          }
        }],
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          data: time
        },
        yAxis: [{
          type: 'value',
          name:'元/吨',
          nameTextStyle:{
            color: '#C1D3F4',
            padding:[0,0,0,-40]
          },
          axisLabel: {
            color: '#C1D3F4',
            // formatter: function (params) {
            //   return parseInt(params/1000)
            // }
          },
          min:val=>{
            return parseInt(val.min/1000)*1000
          },
          splitLine:{
            show:false
          }
        },{
          type: 'value',
          name:'%',
          axisLabel: {
            color: '#C1D3F4',
          },
          nameTextStyle:{
            color: '#C1D3F4',
            padding:[0,0,0,35]
          },
          splitLine: {
            lineStyle: {
              color: '#2345AB'
            }
          }
        }],
        series: data
      }
      myEchartst.setOption(option,true)
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: url("../../assets/secondary/bg-1.jpg");
}
.secondary-content{
  width: 100%;
  height: 100%;
  padding-top: 96px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}

.indexmacro-l{
  width: 526px;
  height: 867px;
}

.borderl{
  width: 100%;
  height: 418px;
  margin-top: 8px;
  background: url("../../assets/secondary/border-9.png") no-repeat center/100%;
}

.borderl h3{
  font-size: 22px;
  font-family: fzskjt;
  font-weight: normal;
  color: #fff;
  text-shadow: 2px 4px 3px rgba(0,0,0,.4);
  letter-spacing: 2px;
  line-height: 70px;
  width: 188px;
  text-align: center;
  margin-left: 31px;
}

.borderl-mian{
  width: 100%;
  padding: 0 28px;
  box-sizing: border-box;
  height: 325px;
}

.indexmacro-c{
  width: 872px;
  height: 867px;
}

.indexmacro-c-t{
  height: 105px;
  width: 100%;
  margin-top: 30px;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.indexmacro-c-t-l{
  width: 50px;
  height: 100%;
  padding-top: 3px;
  box-sizing: border-box;
}

.indexmacro-c-t-l span{
  width: 100%;
  display: inline-block;
  height: 31px;
  text-align: center;
  line-height: 31px;
  font-size: 16px;
  color: #fff;
  font-family: fzskjt;
  background: #0065A2;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  cursor: pointer;
  margin-bottom: 4px;
}

.indexmacro-c-t-l span:hover{
  background: #0078BF;
}

.indexmacro-c-t-l span.on{
  background: #0092E9;
  text-shadow: 1px 3px 3px rgba(0,0,0,.5);
}

.indexmacro-c-t-r{
  width: 799px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.weekindex{
  width: 153px;
  height: 100%;
  border-radius: 4px;
  color: #fff;
  padding: 16px 10px;
  box-sizing: border-box;
  position: relative;
  background:linear-gradient(to bottom right,#148FE5,#2B58C1);
  cursor: pointer;
}

.weekindex:before{
  content: '';
  position: absolute;
  left: 50%;
  right: 50%;
  bottom: 0;
  background: #fff;
  height: 3px;
  -webkit-transition-property: 'left, right';
  -o-transition-property: 'left, right';
  transition-property: 'left, right';
  -webkit-transition-duration: .3s;
  -o-transition-duration: .3s;
  transition-duration: .3s;
  -webkit-transition-timing-function: ease-out;
  -o-transition-timing-function: ease-out;
  transition-timing-function: ease-out
}

.fall{
  background:linear-gradient(to bottom right,#148FE5,#0BA46A);
}

.rose{
  background:linear-gradient(to bottom right,#148FE5,#FF0000);
}

.weekindex:hover:before{
  left: 0;
  right: 0
}

.weekindex-bg{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background: url("../../assets/secondary/bg-5.png") no-repeat right;
}

.triangle{
  width: 0;
  height: 0;
  opacity: 0;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-bottom: 14px solid white;
}

.on .triangle{
  opacity: 1;
}

.weekindex h3{
  font-size: 24px;
  font-weight: normal;
  text-shadow: 4px 3px 5px rgba(0,0,0,.3);
  margin-bottom: 10px;
  font-family: 'fzskjt';
}

.weekindex p{
  display: flex;
  justify-content: space-between;
}

.weekindex b{
  font-size: 36px;
  font-family: Bahnschrift;
  text-shadow: 4px 3px 7px rgba(0,0,0,.4);
}

.weekindex i{
  display: block;
  font-style: normal;
  font-family: Bahnschrift;
  font-size: 16px;
  text-align: right;
  text-shadow: 1px 2px 2px rgba(0,0,0,.4);
}

.triangle{
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 16px solid white;
}

.indexmacro-c-b{
  width: 845px;
  height: 714px;
  margin: 0 auto;
  background: url("../../assets/secondary/border-11.png") no-repeat center/100%;
}

.indexmacro-c-b-mian{
  width: 100%;
  height: 50%;
}

.indexmacro-r{
  width: 520px;
  height: 867px;
  margin-top: -16px;
}

.borderr{
  width: 100%;
  height: 293px;
  margin-top: -2px;
  background: url("../../assets/secondary/border-10.png") no-repeat center/100%;
}

.borderr h3{
  font-size: 22px;
  font-family: fzskjt;
  font-weight: normal;
  color: #fff;
  text-shadow: 2px 4px 3px rgba(0,0,0,.4);
  letter-spacing: 2px;
  line-height: 65px;
  width: 208px;
  text-align: center;
  margin-left: 28px;
}

.borderr-mian{
  width: 100%;
  padding: 0 25px;
  box-sizing: border-box;
  height: 210px;
}
</style>



// WEBPACK FOOTER //
// src/views/secondary/indexmacro.vue